import React from 'react';
import {
  Panel,
  RefinementList,
} from 'react-instantsearch-dom';

function TitleFilterPanel() {
  return (
    <div className="card mb-3">
      <div className="card-body ais-hide-counts">
        <Panel header="Filter by title">
          <RefinementList
            attribute="current_positions.title"
            limit={6}
            showMore={true}
            showMoreLimit={15}
            searchable={true}
          />
        </Panel>
      </div>
    </div>
  );
}

export default TitleFilterPanel;
